import React from "react";
import { Chip, Paper, Stack, Typography } from "@mui/material";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { useTranslation } from "../i18n/useTranslation";

const ActiveFiltersBar = ({ filters = [] }) => {
  const { t } = useTranslation();
  const hasFilters = filters.length > 0;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid rgba(15,23,42,0.08)",
        bgcolor: "rgba(15,23,42,0.02)",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.5}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <FilterAltOffIcon color={hasFilters ? "primary" : "disabled"} />
          <Typography variant="subtitle2" color="text.secondary">
            {t("filters.heading")}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} flexWrap="wrap">
          {hasFilters ? (
            filters.map((filter) => (
              <Chip
                key={filter.key}
                label={filter.label}
                onDelete={filter.onRemove}
                sx={{
                  borderRadius: 999,
                  fontWeight: 600,
                }}
              />
            ))
          ) : (
            <Chip
              label={t("filters.none")}
              disabled
              sx={{ borderRadius: 999, fontWeight: 500 }}
            />
          )}
        </Stack>
      </Stack>
    </Paper>
  );
};

export default ActiveFiltersBar;
